import { io } from "socket.io-client";

export const socket = io('/notifications', {
    timeout: 5000,
    autoConnect: true,
    withCredentials: true,
    transports: ['websocket'],
    query: {},
});